import { ChevronIcon } from "@hub/ui/icons/chevron-icon";
import React from "react";
import styles from "./options-button.module.css";

interface OptionsButtonProps {
  openModal: () => void;
}

export const OptionsButton: React.FC<OptionsButtonProps> = ({ openModal }) => {
  return (
    <div className={styles.optionsButton} onClick={openModal}>
      <span className={styles.optionsButton__label}>Options</span>
      <ChevronIcon />
    </div>
  );
};
